<template>

  <iframe v-if="model==22" id="inlineFrameExample"
    :src="'https://rhino.sens-eye.fr/examples/lemtosh/?order_item='+this.$route.params.id+'&token='+token" />

    <iframe v-else id="inlineFrameExample"
    :src="'https://rhino.sens-eye.fr/examples/meyro/?order_item='+this.$route.params.id+'&token='+token" />
</template>

<script>
import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BRow
  },
  data() {
    return {
      token:localStorage.token_senseye_auth,
      model:22
    }
  },
  props:['scan','language'],
  
  methods:{

  },
  watch:{
    
  },
  async mounted()
  {
    let order_item=await APIRequest.detail('order-items',this.$route.params.id)
    console.log('mounted')
    console.log(order_item.glass.id)
    if(order_item.glass.id!=22)
    {
      this.model=order_item.glass.id
    }
  }
}
</script>

<style lang="scss" >
#inlineFrameExample {
    width:100%;
    height:100vh;
    border:0;
}
</style>
